import * as React from "react";
const SvgFiRrSword = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sword_svg__a)">
      <path
        fill="#062147"
        d="M23.414.587a2.02 2.02 0 0 0-1.941-.513 16.46 16.46 0 0 0-6.48 3.983l-9.475 9.475a14.6 14.6 0 0 0-4.376-1.522 1 1 0 0 0-.286 1.98 12.6 12.6 0 0 1 5.353 2.386l-3.71 3.71-.792-.793a1 1 0 1 0-1.414 1.414l3 3a1 1 0 1 0 1.414-1.414l-.793-.793 3.709-3.71a12.6 12.6 0 0 1 2.387 5.354 1 1 0 0 0 1.98-.285 14.5 14.5 0 0 0-1.521-4.376l9.475-9.476a16.5 16.5 0 0 0 4.01-6.574 2 2 0 0 0-.54-1.846m-4.885 7.005L9.362 16.76q-.457-.6-.988-1.134a11 11 0 0 0-1.133-.988l9.167-9.167a14.4 14.4 0 0 1 5.584-3.464 14.45 14.45 0 0 1-3.463 5.585"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sword_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSword;
